var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_107",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XLS",
    transform: "translate(-2018.208 -1679.208)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2018.21, 1679.21)",
    filter: "url(#Ellipse_107)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107-2",
    "data-name": "Ellipse 107",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(12 10)",
    fill: "#3276cf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "xls-file",
    d: "M58.84,0H48.8a2.665,2.665,0,0,0-2.661,2.661V12.5h-.26a1.072,1.072,0,0,0-1.072,1.072v6.5a1.072,1.072,0,0,0,1.072,1.072h.26v1.192A2.664,2.664,0,0,0,48.8,25H62.5a2.664,2.664,0,0,0,2.66-2.661V6.3Zm-11.3,14.686h1.171l.395.823c.134.274.235.5.342.749h.013c.107-.288.194-.489.308-.749l.381-.823h1.164l-1.271,2.2L51.376,19.2H50.2l-.408-.816c-.167-.315-.274-.548-.4-.81h-.013c-.094.261-.208.5-.348.81l-.375.816H47.488l1.3-2.282ZM62.5,23.37H48.8a1.032,1.032,0,0,1-1.031-1.031V21.147H60.54a1.072,1.072,0,0,0,1.072-1.072v-6.5A1.072,1.072,0,0,0,60.54,12.5H47.768V2.661A1.032,1.032,0,0,1,48.8,1.631l9.431-.01V5.107a1.846,1.846,0,0,0,1.845,1.845l3.415-.01.038,15.4A1.031,1.031,0,0,1,62.5,23.37Zm-7.756-5.032V19.2H51.927V14.686H52.95v3.653ZM56.472,17.3c-.749-.261-1.238-.676-1.238-1.331,0-.77.642-1.358,1.706-1.358a2.769,2.769,0,0,1,1.151.227l-.228.823a2.148,2.148,0,0,0-.944-.214c-.442,0-.656.2-.656.435,0,.288.254.415.836.636.8.294,1.171.709,1.171,1.345,0,.756-.582,1.4-1.82,1.4a2.949,2.949,0,0,1-1.278-.275l.208-.843a2.6,2.6,0,0,0,1.131.28c.468,0,.716-.194.716-.488S57.014,17.5,56.472,17.3Z",
    transform: "translate(2000.226 1701.708)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/XLS.b7eca81101090e62c1368719fe8615a6.svg";
export { ForwardRef as ReactComponent };